import {call, put, takeLatest} from 'redux-saga/effects'
import {  dashboardLoaderAC } from '../system/systemActionCreators'
import {getHandoverRecordsList} from './dHandoverRecordAPI'
import {IdHandoverRecordStateDataItem, typeHandoverRecordFilters} from './dHandoverRecordReducer'
import {dHRecordSetDataAC, dHRecordSetDataSagaAC, dHRecordSetPaginationAC} from './dHandoverRecordActionCreators'
import {
    typePagination,
    typeRequestPagination,
    paginationMapper,
} from '../system/constants'
import { errorGenerator } from 'model/system/utils';


// Temp data list mapper
const tempDataMapper = (tempResponseData: any): IdHandoverRecordStateDataItem[] => {
    return tempResponseData.map((item:IdHandoverRecordStateDataItem) => {
        return(
            {
                checked: false,
				cashierId: item.cashierId,
                cashierName: item.cashierName,
				closeDate: item.closeDate,
				id: item.id,
				pos: item.pos,
				openDate: item.openDate,
				refundsAmount: item.refundsAmount,
				refundsCount: item.refundsCount,
				refundsWithCards: item.refundsWithCards,
				refundsWithCash: item.refundsWithCash,
                refundsWithCashless: item.refundsWithCashless,

                salesAmount: item.salesAmount,
				salesCount: item.salesCount,
				salesWithCards: item.salesWithCards,
				salesWithCash: item.salesWithCash,
                salesWithCashless: item.salesWithCashless,
				userId: item.userId,
				userName: item.userName
            }
        )
    })
}

// Get data function-generator
function* getData(payload: { filters: typeHandoverRecordFilters, paginationRequest: typeRequestPagination}) {


    let response = yield call(getHandoverRecordsList, payload)

    if (response.status === 200) {

        const tempData: IdHandoverRecordStateDataItem[] = tempDataMapper(response.data.content)
        const pagination: typePagination = paginationMapper(response.data)

        yield put(dHRecordSetPaginationAC(pagination))

        yield put(dHRecordSetDataAC(tempData))

    } else {
        yield errorGenerator(response)
    }
}

// ---------------------------------------------------------------------------------------------------------------------
// Set HandoverRecords list saga
export function* dHRecordsSetDataWorker (
    actionObject:{
		type: string,
		payload: {
			filters: typeHandoverRecordFilters,
			paginationRequest: typeRequestPagination
		}
	}) {

		yield put(dashboardLoaderAC(true))

		yield getData(actionObject.payload)

		yield put(dashboardLoaderAC(false))
	}

	export function* dHRecordsSetDataWatcher () {
		yield takeLatest(dHRecordSetDataSagaAC.type, dHRecordsSetDataWorker)
	}
